"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.timeoutPromise = timeoutPromise;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

function timeoutPromise(_x) {
  return _timeoutPromise.apply(this, arguments);
}

function _timeoutPromise() {
  _timeoutPromise = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(promise) {
    var timeToWait,
        timeoutId,
        timeoutPromise,
        promiseToWaitFor,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            timeToWait = _args.length > 1 && _args[1] !== undefined ? _args[1] : 10000;
            timeoutPromise = new _promise["default"](function (resolve, reject) {
              timeoutId = setTimeout(function () {
                reject(new Error('Promise timed out'));
              }, timeToWait);
            });
            promiseToWaitFor = new _promise["default"](function (resolve, reject) {
              promise.then(function (result) {
                clearTimeout(timeoutId);
                resolve(result);
              })["catch"](function (error) {
                clearTimeout(timeoutId);
                reject(error);
              });
            });
            return _context.abrupt("return", _promise["default"].race([timeoutPromise, promiseToWaitFor]));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _timeoutPromise.apply(this, arguments);
}